// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Prizes_wrapper_3y16Q","centered":"Prizes_centered_GYVnC"};